import { IS_DROPSTAB_TEAM_USER } from "@tradingApp/constants";

const loadTrading = async () => {
  return import("@tradingApp/main");
};

const loadGame = async () => {
  return import("@gameApp/main");
};

if (IS_DROPSTAB_TEAM_USER) {
  loadTrading().then(({ tradingAppInit }) => {
    tradingAppInit();
  });
} else {
  loadGame().then(({ gameAppInit }) => {
    gameAppInit();
  });
}
